export const notificationAudio = new Audio(
  "https://gotastelivestorage.blob.core.windows.net/gotasteimages/ringtone-021-365652.mp3",
);

notificationAudio.volume = 0.5;
notificationAudio.preload = "auto";
